import React, { useState } from 'react';

import UsersTable from '../Table';

import { useStyles } from './styles';

export default ({listDataChange}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <UsersTable
        listDataChange={listDataChange}
      />
    </div>
  );
};
